
const skillsContent = [
    {
      title: "Languages",
      skills: [
        "Python",
        "JavaScript",
        "Java",
        "TypeScript",
        "SQL",
        "HTML",
        "CSS"
        
      ],
    },
    {
      title: "Technologies",
      skills: [
        "Flask",
        "React",
        "MySQL",
        "PostgreSQL",
        "Node.js",
        "Express.JS",
        "Spring Boot",
        "Docker",
        "AWS",
    
      ],
    },
    {
      title: "Other",
      skills: [
        "Software Architecture",
        "Object-Oriented Design",
        "Git",
        "CI/CD",
        "Agile",
      ],
    },
  ];
  
  export default skillsContent;
  